var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('ProfileHeader'),_c('vca-row',[_c('vca-card',{staticClass:"shadowed"},[_c('UsersGeneral'),_c('UsersNewsletter')],1),_c('vca-card',{staticClass:"shadowed"},[_c('UsersCrew'),_c('UsersAddress')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }